/**
 * 移动端适配 composable
 */
import { ref, onMounted, onBeforeUnmount } from 'vue';

export function useResponsive() {
  const isMobile = ref(false);
  const screenWidth = ref(window.innerWidth);

  const checkIsMobile = () => {
    screenWidth.value = window.innerWidth;
    isMobile.value = window.innerWidth <= 768;
  };

  onMounted(() => {
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    window.addEventListener('orientationchange', checkIsMobile);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', checkIsMobile);
    window.removeEventListener('orientationchange', checkIsMobile);
  });

  return { isMobile, screenWidth };
}
